import React from "react";
import { NavLink } from "react-router-dom";

export default function ButtonLiens(props) {
  // Combine props.buttonClass with an additional class, e.g., "extra-class"
  const combinedClass = `${props.buttonClass || ""} btn-decoration`.trim();

  return (
    <NavLink
      to={props.buttonLink}
      target={props.buttonTarget}
      className={combinedClass}
    >
      {/* <div className="submit-btn text-center">{props.buttonText}</div> */}
      <div className="animate-btn">
        <div className="text-center z-3 btn-text">{props.buttonText}</div>
      </div>
    </NavLink>
  );
}
